var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "my_jsplumb" + _vm.randomStr,
      staticClass: "my_jsplumb",
      on: { click: _vm.addWatch },
    },
    [
      _vm.isEdit
        ? _c(
            "div",
            { staticClass: "mjLeft" },
            [
              _c(
                "draggable",
                {
                  staticClass: "mjLeft-drag",
                  attrs: {
                    list: _vm.elementList,
                    animation: 100,
                    "item-key": "index",
                    forceFallback: true,
                    "ghost-class": "ghost",
                    sort: false,
                  },
                  on: { end: _vm.dragWidget },
                },
                [
                  _vm._l(_vm.elementList, function (i, n) {
                    return _c("div", { key: n, attrs: { id: i.type } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mjLeft-items",
                          class: "mjLeft-items_" + i.type,
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(i.name)),
                          ]),
                        ]
                      ),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: _vm.regionId,
          staticClass: "mjRight",
          class: _vm.isEdit ? "mjRightEdit" : "",
          attrs: { id: _vm.regionId },
        },
        [
          _vm._l(_vm.nodeList, function (item, n) {
            return _c(
              "div",
              {
                key: item.clientId,
                staticClass: "mjRight-items  mjRight-items_node",
                style: _vm.getNodeStyle(item),
                attrs: { id: item.clientId },
                on: {
                  click: function ($event) {
                    return _vm.handleClickElements("node", item.id, "click", n)
                  },
                },
              },
              [
                _vm._v("\n     " + _vm._s(item.name) + "\n      "),
                _vm.isEdit
                  ? _c(
                      "div",
                      {
                        staticClass: "mjRight-items_del",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.delNode(item.clientId, "node", item.id)
                          },
                        },
                      },
                      [_vm._v("x")]
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.frameList, function (item, n) {
            return _c(
              "div",
              {
                key: item.clientId,
                staticClass: "mjRight-items  mjRight-items_frame",
                style: _vm.getFrameStyle(item),
                attrs: { id: item.clientId },
                on: {
                  click: function ($event) {
                    return _vm.handleClickElements("frame", item.id, "click", n)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "mjRight-items_framName",
                    style: _vm.getPosition(item.namePosition),
                  },
                  [_vm._v(" " + _vm._s(item.name))]
                ),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "div",
                      {
                        staticClass: "mjRight-items_del",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.delNode(item.clientId, "frame", item.id)
                          },
                        },
                      },
                      [_vm._v("x")]
                    )
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }